import { render, staticRenderFns } from "./changePwPage.vue?vue&type=template&id=454ab2d1&scoped=true&"
import script from "./changePwPage.vue?vue&type=script&lang=js&"
export * from "./changePwPage.vue?vue&type=script&lang=js&"
import style0 from "./changePwPage.vue?vue&type=style&index=0&id=454ab2d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ab2d1",
  null
  
)

export default component.exports